// Íconos SVG del modal "Accesos por organización" (trazo, heredan el color del texto).
const base = { width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" as const, strokeLinejoin: "round" as const, "aria-hidden": true }

export const IconoChevron = ({ abierto }: { abierto: boolean }) => (
    <svg {...base} className={`tw-transition-transform tw-duration-150 ${abierto ? "tw-rotate-90" : ""}`}><polyline points="9 6 15 12 9 18" /></svg>
)

export const IconoBuscar = () => (
    <svg {...base}><circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
)

export const IconoEdificio = () => (
    <svg {...base}><rect x="4" y="3" width="16" height="18" rx="1" /><line x1="9" y1="7" x2="9" y2="7.01" /><line x1="15" y1="7" x2="15" y2="7.01" /><line x1="9" y1="11" x2="9" y2="11.01" /><line x1="15" y1="11" x2="15" y2="11.01" /><path d="M10 21v-4h4v4" /></svg>
)

export const IconoSucursal = () => (
    <svg {...base}><path d="M3 9l9-6 9 6" /><path d="M5 9v11h14V9" /><path d="M10 20v-5h4v5" /></svg>
)

export const IconoGrupo = () => (
    <svg {...base}><circle cx="9" cy="8" r="3" /><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" /><circle cx="17" cy="9" r="2.5" /><path d="M16 14.2c2.8.4 5 2.8 5 5.8" /></svg>
)

export const IconoObjetivo = () => (
    <svg {...base}><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1" /></svg>
)

export const IconoInfo = () => (
    <svg {...base}><circle cx="12" cy="12" r="9" /><line x1="12" y1="11" x2="12" y2="16" /><line x1="12" y1="8" x2="12" y2="8.01" /></svg>
)
